module.exports = __webpack_public_path__ + "img/Blue Marble.54c7ce53.jpg";